import axios from "axios";
import { getEnhancedAuthHeaders } from "./auth";
const backendUrl = process.env.REACT_APP_BACKEND_URL_FOR_FRONTEND;

export const getLast5ActivityLogsByUserId = async (userId, userCompanyId) => {
    console.log("userId", userId);
    console.log("userCompanyId", userCompanyId);
  if (!userId || !userCompanyId) {
    throw new Error("User ID and Company ID are required");
  }
  
  try {
    const response = await axios.get(`${backendUrl}/logs/user/last5activity/${userId}?companyId=${userCompanyId}`, {
      headers: getEnhancedAuthHeaders(),
    });
    return response.data;
  } catch (error) {
    throw new Error(error.message);
  }
};
